import React ,{useEffect , useState} from "react";
import { useSwiper } from "swiper/react";
import {ReactComponent as RightArrow} from "../../../assets/rightarrow.svg";
import "./CarouselRightNavigation.css"

export default function CarouselRightNavigation(){
    const swiper =useSwiper();
    const [isEnd ,setIsEnd]=useState(swiper.isEnd);

    useEffect(()=>{
        swiper.on("slideChange" ,function(){
            setIsEnd(swiper.isEnd);
        });
    },[]);


    return (
        <div className="rightNavigation">
            {!isEnd && <RightArrow onClick ={()=> swiper.slideNext()}/>}
        </div>
    )
}